import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Archive } from "lucide-react";

const ArchiveDialogSection = ({ ctx }) => {
  const {
    archiveDialogOpen,
    archiveReason,
    archiveRemarks,
    employeeToArchive,
    handleArchiveEmployee,
    setArchiveDialogOpen,
    setArchiveReason,
    setArchiveRemarks
  } = ctx;
  return (
    <>
      <Dialog open={archiveDialogOpen} onOpenChange={setArchiveDialogOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="font-heading text-xl flex items-center gap-2">
              <Archive className="w-5 h-5 text-amber-600" />
              Archive Employee (Removal)
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div className="bg-amber-50 border border-amber-200 p-3 rounded-sm">
              <p className="text-sm text-amber-800">
                You are about to archive <span className="font-semibold">{employeeToArchive?.name}</span> ({employeeToArchive?.employee_code}).
              </p>
              <p className="text-xs text-amber-600 mt-1">
                The employee will be moved to archives. All historical data (attendance, leave, etc.) will be preserved.
              </p>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">
                Reason for Removal <span className="text-error">*</span>
              </label>
              <select
                value={archiveReason}
                onChange={(e) => setArchiveReason(e.target.value)}
                className="w-full p-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary"
              >
                <option value="">Select a reason</option>
                <option value="Resigned">Resigned</option>
                <option value="Contract Ended">Contract Ended</option>
                <option value="Project Completed">Project Completed</option>
                <option value="Terminated">Terminated</option>
                <option value="Transferred">Transferred to Another Project</option>
                <option value="Retired">Retired</option>
                <option value="Absconded">Absconded</option>
                <option value="Other">Other</option>
              </select>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">
                Additional Remarks
              </label>
              <textarea
                value={archiveRemarks}
                onChange={(e) => setArchiveRemarks(e.target.value)}
                placeholder="Any additional details (e.g., last working date, settlement details)..."
                className="w-full p-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary h-20 resize-none"
              />
            </div>
          </div>
          <div className="flex justify-end gap-3">
            <button
              onClick={() => setArchiveDialogOpen(false)}
              className="px-4 py-2 border border-slate-300 rounded-sm text-slate-700 hover:bg-slate-100"
            >
              Cancel
            </button>
            <button
              onClick={handleArchiveEmployee}
              disabled={!archiveReason}
              className="px-4 py-2 bg-amber-600 text-white rounded-sm hover:bg-amber-700 disabled:bg-slate-300 disabled:cursor-not-allowed"
            >
              Archive Employee
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ArchiveDialogSection;
